import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/issueBulkInvoices', request)
}

export {post}
